import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrderDto } from '../../dtos/order.dto';
import { tap } from 'rxjs/operators';
import { ResponseDto } from '../../dtos/response.dto';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { AddOrderDto } from '../../dtos/add-order.dto';
import { ShippingMethodEnum } from '../../enums/shipping-method.enum';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private http = inject(HttpClient);

  orderPlaced$ = new Subject<void>();
  shippingMethod$ = new BehaviorSubject<ShippingMethodEnum>(null);

  placeOrder(addOrderDto: AddOrderDto) {
    return this.http.post<ResponseDto<OrderDto>>(`${environment.apiHost}/api/v1/order`, addOrderDto)
      .pipe( tap(_ => this.orderPlaced$.next()) );
  }

  fetchOnlinePaymentDetails(orderId: number) {
    return this.http.get<ResponseDto<any>>(`${environment.apiHost}/api/v1/order/${orderId}/online-payment-details`);
  }

  fetchCardPaymentDetails(orderId: number) {
    return this.http.get<ResponseDto<any>>(`${environment.apiHost}/api/v1/order/${orderId}/card-payment-details`);
  }
}
